/* global ImageCropper */

import { Controller } from "@hotwired/stimulus";
import { applyImageHandling } from "../mixins/image_handling.js";
import { applyUiInteractions } from "../mixins/ui_interactions.js";
import { persistCropperStateToDOM } from "../mixins/setup_image_cropper.js";

export default class extends Controller {
  initialize() {
    applyImageHandling(this);
    applyUiInteractions(this);
  }

  persistLogoCropperState(options) {
    const {
      containerSelector,
      cropperInstance,
      imageUrl,
      imageName,
      hiddenDivClass = 'logo-cropper-details'
    } = options;

    const activeTab = document.querySelector('.tabbed .tabbed__trigger.active')?.getAttribute('data-for-tab');

    persistCropperStateToDOM({
      containerSelector,
      cropperInstance,
      imageUrl,
      imageName,
      hiddenDivClass,
      activetab: activeTab,
    });
  }

  applyLogoFromImage(image, imageName) {
    this.submitForm(image, imageName);
  }

  applyLogoFromCropper(cropper, imageName) {
    const canvas = cropper.get_cropped_canvas();
    const mimeType = cropper.get_image_mime_type();
    canvas.toBlob((blob) => {
      this.submitForm(blob, imageName);
    }, mimeType);
  }

  submitForm(blob, imageName) {
    const url = URL.createObjectURL(blob);
    window.blobs = { ...window.blobs, logo: blob };

    this.updateHiddenField("#site_logo_library_file_id", "");
    this.updateHiddenField("#site_logo_preview_name", imageName);
    this.updateHiddenField("#site_logo_preview_url", url);

    const form = document.querySelector("form.header_form");
    if (form) {
      form.requestSubmit();
    }
  }

  updateHiddenField(selector, value) {
    const field = document.querySelector(selector);
    if (field) {
      field.value = value;
    }
  }

  cropperHasChanges() {
    return this.mediaSelectCropper?.hasChanged();
  }

  showProcessingLoader() {
    window.modal.close();
    $(".logo-image-section-loading").fadeIn("fast");
    $(".site-logo-images").animate({ opacity: 0.1 }, "fast");
  }

  initializeLogoCropper(container, initialData) {
    return new ImageCropper(container, initialData ? { data: initialData, edit_cropping: true } : undefined);
  }
}
